import { Link } from "react-router-dom";

import { useMediaPredicate } from 'react-media-hook';
import { MOBILE_SIZE } from 'utils/mediaQueryUtils';

import GoogleAddressSearchV2 from 'components/addressSearch/GoogleAddressSearchV2';
import BlockAndLotSearch from 'components/addressSearch/BlockAndLotSearch';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import './HeaderSearch.css';

const HeaderSearch = (props) => {
	const isMobile = useMediaPredicate(MOBILE_SIZE);
	const hideHeaderSearch = props.hideHeaderSearch;
	const showHeaderHint = props.showHeaderHint;

	if (isMobile) {
		return (
			<span className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center">
				<Link to="/search" aria-label="Search" className="tw-text-icon-primary hover:tw-text-icon-primary">
					<SearchIcon className="tw-h-4 tw-w-4" aria-hidden="true" />
				</Link>
			</span>
		);
	}

	//desktop only
	return (
		<div className="app-header-search-v3 tw-flex tw-items-center tw-gap-6">
			{!hideHeaderSearch && <GoogleAddressSearchV2 hideLabel placeholder="Address" showHeaderHint={showHeaderHint} />}
			{!hideHeaderSearch && <BlockAndLotSearch hideLabel />}
		</div>
	);
};

export default HeaderSearch;
